module.exports = __webpack_public_path__ + "static/media/Meleager.35b39c2f.jpg";